<template>
    <div class="card-panel">
        <el-tooltip effect="dark" popper-class="wring-text"  placement="right" 
            :disabled="!isFindSubRouter && !$G_DEVICE_CFG.isSubRouter"
            :content="!$G_DEVICE_CFG.isSubRouter
            ?'Modifying this parameter may cause the subRouter network to be down. Prohibit operation!'
            :'It is forbidden to modify the wireless switch in subRouter mode!'"
            v-if="$G_DEVICE_CFG.area != 'CIK'">
        <div class="card-body" >
            <h4>Wireless</h4>
            <div class="line-header"></div>
            <!-- 双频优先 -->
            <div class="row form-group boder-bottom group-lg" v-if="$isINTL">
                <div class="col-xs-3">
                    <i class="iconfont icon-neighbor band-icon" ></i>
                    <!-- <img src="@/assets/img/nav_left/ic_wifi_tethering_1.png" class="band-icon" alt="wifi"> -->
                </div>
                <div class="col-xs-6">
                    <p class="wifi-title"><strong>Band Steering Enable</strong> </p>
                </div>
                <div class="col-xs-3">
                    <el-switch v-model="wlBandSteering"
                    @change="setWlBandSteering"
                    :disabled="$G_DEVICE_CFG.isReadOnly || $G_DEVICE_CFG.isSubRouter || isFindSubRouter  || loading"></el-switch>
                </div>
            </div>
            <div class="row form-group boder-bottom">
                <div class="col-xs-3">
                    <div class="wifi">
                        <div class="level-1"></div>
                        <div class="level-2"></div>
                        <div class="level-3"></div>
                    </div>
                </div>
                <div class="col-xs-6">
                    <p class="wifi-title" v-if="!wlBandSteering">2.4 GHz</p>
                    <p class="wifi-info">{{wl1SSID}}</p>
                    <p class="wifi-action">
                        <a href="#" @click="goTOPWL1">CHANGE</a>
                    </p>
                </div>
                <div class="col-xs-3">
                    <el-switch v-model="wl1Enable" @change="setWlEnable(1)"
                    :disabled="$G_DEVICE_CFG.isReadOnly || $G_DEVICE_CFG.isSubRouter || isFindSubRouter  || loading"></el-switch>
                </div>
            </div>
            <div class="row form-group boder-bottom" v-if="!wlBandSteering">
                <div class="col-xs-3">
                    <div class="wifi">
                        <div class="level-1"></div>
                        <div class="level-2"></div>
                        <div class="level-3"></div>
                    </div>
                </div>
                <div class="col-xs-6">
                    <p class="wifi-title">5 GHz</p>
                    <p class="wifi-info">{{wl0SSID}}</p>
                    <p class="wifi-action">
                        <a href="#" @click="goTOPWL0">CHANGE</a>
                    </p>
                </div>
                <div class="col-xs-3">
                    <el-switch v-model="wl0Enable" @change="setWlEnable(0)" 
                    :disabled="$G_DEVICE_CFG.isReadOnly ||  $G_DEVICE_CFG.isSubRouter || isFindSubRouter || loading"></el-switch>
                </div>
            </div>
            
        </div>
        </el-tooltip>
        
        <div class="card-body" v-else>
            <h4>Wireless</h4>
            <div class="line-header"></div>
            <!-- 双频优先 -->
            <div class="row form-group boder-bottom group-lg" v-if="$isINTL">
                <div class="col-xs-3">
                    <i class="iconfont icon-neighbor band-icon" ></i>
                    <!-- <img src="@/assets/img/nav_left/ic_wifi_tethering_1.png" class="band-icon" alt="wifi"> -->
                </div>
                <div class="col-xs-6">
                    <p class="wifi-title"><strong>Band Steering Enable</strong> </p>
                </div>
                <div class="col-xs-3">
                    <el-switch v-model="wlBandSteering"
                    @change="setWlBandSteering"
                    :disabled="$G_DEVICE_CFG.isReadOnly || loading"></el-switch>
                </div>
            </div>
            <el-tooltip effect="dark" popper-class="wring-text"  placement="right" 
            :disabled="!isFindSubRouter && !$G_DEVICE_CFG.isSubRouter"
            :content="!$G_DEVICE_CFG.isSubRouter
            ?'Modifying this parameter may cause the subRouter network to be down. Prohibit operation!'
            :'It is forbidden to modify the wireless switch in subRouter mode!'">
            <div>
            <div class="row form-group boder-bottom">
                <div class="col-xs-3">
                    <div class="wifi">
                        <div class="level-1"></div>
                        <div class="level-2"></div>
                        <div class="level-3"></div>
                    </div>
                </div>
                <div class="col-xs-6">
                    <p class="wifi-title" v-if="!wlBandSteering">2.4 GHz</p>
                    <p class="wifi-info">{{wl1SSID}}</p>
                    <p class="wifi-action">
                        <a href="#" @click="goTOPWL1">CHANGE</a>
                    </p>
                </div>
                <div class="col-xs-3">
                    <el-switch v-model="wl1Enable" @change="setWlEnable(1)"
                    :disabled="$G_DEVICE_CFG.isReadOnly || $G_DEVICE_CFG.isSubRouter || isFindSubRouter  || loading"></el-switch>
                </div>
            </div>
            <div class="row form-group boder-bottom" v-if="!wlBandSteering">
                <div class="col-xs-3">
                    <div class="wifi">
                        <div class="level-1"></div>
                        <div class="level-2"></div>
                        <div class="level-3"></div>
                    </div>
                </div>
                <div class="col-xs-6">
                    <p class="wifi-title">5 GHz</p>
                    <p class="wifi-info">{{wl0SSID}}</p>
                    <p class="wifi-action">
                        <a href="#" @click="goTOPWL0">CHANGE</a>
                    </p>
                </div>
                <div class="col-xs-3">
                    <el-switch v-model="wl0Enable" @change="setWlEnable(0)" 
                    :disabled="$G_DEVICE_CFG.isReadOnly ||  $G_DEVICE_CFG.isSubRouter || isFindSubRouter || loading"></el-switch>
                </div>
            </div>
            </div>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
import devConfig from '@/devConfig'
export default {
    data() {
        return {
            loading:true,
            wlBandSteering:false,
            wl1Enable: true,
            wl1SSID:"",
            wl0Enable: true,
            wl0SSID:"",
            isFindSubRouter:false,
        }
    },
    created(){
         devConfig.init(this,()=>{
            this.isFindSubRouter = this.$G_DEVICE_CFG.isFindSubRouter
            this.getData()
        })
    },

    methods:{
        getData(){
            axios
            .post("/JSONAPI",{cmdType:"HOME_GET_WLAN_INFO"})
            .then((response)=>{
                this.loading = false
                if(response.data.ret == '0')
                {
                    this.wl1Enable = response.data.wl1Enable
                    this.wl1SSID = response.data.wl1SSID
                    this.wl0Enable = response.data.wl0Enable
                    this.wl0SSID = response.data.wl0SSID
                    this.wlBandSteering = response.data.wlBandSteering

                    // 更新全局 Band Steering 状态
                    this.$G_DEVICE_CFG.isWlBandSteering = response.data.wlBandSteering
                    devConfig.update(this.$G_DEVICE_CFG)
                }
            })
        },
        setWlEnable(wlindex){
            this.loading = true
            axios
            .post("/JSONAPI",{
                cmdType:"HOME_SET_WLAN_ENABLE",
                wlEnable:wlindex === 1 ? this.wl1Enable : this.wl0Enable,
                wlIndex:wlindex
            })
            .then((response)=>{
                setTimeout(()=>{
                    this.loading = false
                    if(response.data.ret == '0')
                        this.$message.success("Configuration is successful!")
                    else
                        this.$message.error("Configuration failed!")
                },6000)
                
            })
        },
        setWlBandSteering(data){
            const loadingInstance = this.$loading({
                lock: true,
            })
            
            axios
            .post("/JSONAPI",{
                cmdType:"HOME_SET_WLAN_BAND_STEERING",
                wlBandSteering:data
            })
            .then((response)=>{
                setTimeout(()=>{
                    if(response.data.ret == '0')
                    {
                        this.$message.success("Configuration is successful!")
                    }
                    else
                    {
                        this.$message.error("Configuration failed!")
                    }
                    window.location.reload()
                },6000)
                
            })

        },
        goTOPWL1(){
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
            this.$router.push({path:'basicSetup',query: { 
                oneIndex: 2,
                twoIndex: 1,
                thrMenuIndex:0 
            }})
        },
        goTOPWL0(){
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
            this.$router.push({path:'basicSetup',query: { 
                oneIndex: 2,
                twoIndex: 1,
                thrMenuIndex: this.$isCLARO ? 0 : 1 //哥伦比亚版本没有单独的5G基本配置页面
            }})
        }
    }
}
</script>

<style lang="scss" scoped>
.band-icon{
    width: 30px;
    height: 30px;
    font-size: 28px;
    font-weight: bold;
    color: $--color-primary;
}
.group-lg{
    padding: 15px 0;
}
</style>


